import React, { ReactElement } from 'react';
import { Loader } from 'b2b-components/theme/components/Loader';
import { Fail } from 'b2b-apps/shop/common/components/Fail';
import { logger } from 'b2b-apps/shop/common/utils/logger/logger';
import { ComponentType, Props } from './';

const PageLoader: ComponentType = (props: Props): ReactElement => {
  const { error } = props;

  if (error && !['timeout', 'error'].includes(error.type)) {
    logger.error(
      `[${error.type || 'unknown'}] ${error.message}`,
      {
        error,
        source: 'PageLoader',
      },
    );
    return (
      <div>
        <Fail error={error} />
      </div>
    );
  }

  return (
    <div>
      <Loader />
    </div>
  );
};

export { PageLoader };
